import { ExecutionStatus, ExecutionSteps } from "../types";

export const statusToProgress = (
  status: ExecutionStatus,
  startingState: ExecutionStatus,
  steps?: ExecutionSteps[]
) => {
  if ([ExecutionStatus.completed, ExecutionStatus.error].includes(status)) {
    return;
  }

  let progress = "";
  if (
    !steps ||
    (steps.includes(ExecutionSteps.screenshot) &&
      steps.includes(ExecutionSteps.transcribe))
  ) {
    if (startingState === ExecutionStatus.transcribing) {
      if (status === ExecutionStatus.screenshotting) {
        progress = "1";
      }
      if (status === ExecutionStatus.transcribing) {
        progress = "2";
      }
      if (status === ExecutionStatus.analysing) {
        progress = "3";
      }
      // if (status === ExecutionStatus.summarizing) {
      //   progress = '4'
      // }
      progress += "/3";
    } else {
      if (status === ExecutionStatus.recording) {
        progress = "1";
      }
      if (status === ExecutionStatus.screenshotting) {
        progress = "2";
      }
      if (status === ExecutionStatus.transcribing) {
        progress = "3";
      }
      if (status === ExecutionStatus.analysing) {
        progress = "4";
      }
      // if (status === ExecutionStatus.summarizing) {
      //   progress = '5'
      // }
      progress += "/4";
    }
  } else if (steps.includes(ExecutionSteps.screenshot)) {
    if (status === ExecutionStatus.screenshotting) {
      progress = "1/1";
    }
  } else if (steps.includes(ExecutionSteps.transcribe)) {
    if (status === ExecutionStatus.transcribing) {
      progress = "1";
    }
    if (status === ExecutionStatus.analysing) {
      progress = "2";
    }
    progress += "/2";
  }
  return progress;
};
